export const openChapters = (chaptersDict) => {
    let openChapters = toArray(chaptersDict).filter(chapter => !chapter.closeDate);
    //openChapters = openChapters.filter(chapter => chapter.game.title !== "No Game");
    openChapters.sort((a, b) => (new Date(a.openDate).getTime() - new Date(b.openDate).getTime()));
    return openChapters;
};

/*eslint no-extend-native: ["error", { "exceptions": ["String"] }]*/
String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
};

export function toArray(obj) {
    if (obj) {
        let array = [];
        Object.keys(obj).forEach(key => {
            array.push(obj[key]);
        });
        return array;
    }
    else return []
}

export function readableApplicationState(state) {
        switch(state) {
            case "step_1_submitted":
            case "step_1_redo_submitted":
                return "Basic Information";
            case "step_1_redo":
                return "Awaiting Basic Information";
            case "step_1_approved":
            case "step_1_redo_approved":
            case "step_2_redo":
                return "Awaiting Extended Information";
            case "step_2_submitted":
            case "step_2_redo_submitted":
                return "Extended Information";
            case "step_3_interview":
                return "Interview";
            case "accepted":
                return "Accepted";
            case "rejected":
                return "Rejected";
            case "closed":
                return "Closed";
            default:
                return null
        }
    }



// WEBPACK FOOTER //
// ./src/common/util.js